import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EIconPath } from '../../../../shared/enums/icons.enum';
import { TCustomField } from '../../custom-fields.model';
import { TBulkCustomFields, TBulkCustomFieldsExtended } from '../bulk-custom-fields.model';

@Component({
  selector: 'pp-bulk-field-time',
  templateUrl: './bulk-field-time.component.html',
  styleUrls: ['../bulk-custom-fields-modal.component.scss'],
  standalone: false,
})
export class BulkFieldTimeComponent {
  @Input() ppCustomField: TCustomField;
  @Input() ppCustomFields: TBulkCustomFields<string>;
  @Input() ppFieldId: string;
  @Input() ppCustomFieldsExtended: TBulkCustomFieldsExtended<string>;
  @Input() ppWorkspaceId: string;
  @Input() ppDisabled = false;

  @Output() ppCustomFieldsExtendedChange = new EventEmitter<TBulkCustomFieldsExtended>();
  @Output() ppCustomFieldsChange = new EventEmitter<TBulkCustomFields>();

  EIconPath = EIconPath;
  disabled = false;

  constructor() {}

  ngOnChanges(): void {
    this.disabled = this.ppDisabled || this.ppCustomField.lockedValue;
  }

  updateTime(time: string, field: TCustomField): void {
    this.ppCustomFields[field.id] = time;

    this.ppCustomFieldsExtended[field.id] = {
      value: this.ppCustomFields[field.id],
      label: field.label,
      type: field.type,
    };

    this.ppCustomFieldsChange.emit(this.ppCustomFields);
    this.ppCustomFieldsExtendedChange.emit(this.ppCustomFieldsExtended);
  }
}
